module.exports = __webpack_public_path__ + "bf2.no1.c2d00462.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/bf2.no1.jpg
// module id = Njlv
// module chunks = 0